(() => {
  const nav = document.querySelector('.sn-mobile-nav');
  if (!nav) return;
  nav.querySelector('[data-sn-focus-search]')?.addEventListener('click', event => {
    const input = document.getElementById('sn-main-search');
    if (!input) return;
    event.preventDefault();
    document.querySelector('.section-header')?.classList.remove('shopify-section-header-hidden');
    input.scrollIntoView({ block: 'center', behavior: 'instant' });
    input.focus({ preventScroll: true });
  });
  nav.querySelector('[data-sn-open-cart]')?.addEventListener('click', event => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.setActiveElement(event.currentTarget);
    drawer.open();
  });
  const headerCart = document.getElementById('cart-icon-bubble');
  const count = nav.querySelector('[data-sn-cart-count]');
  const sync = () => {
    const text = headerCart?.querySelector('.cart-count-bubble [aria-hidden="true"]')?.textContent?.trim() || '';
    if (count) { count.textContent = text; count.hidden = !text; }
  };
  if (headerCart) new MutationObserver(sync).observe(headerCart, { subtree: true, childList: true, characterData: true });
  sync();
})();
